import {startLoading, stopLoading} from "../loaders";
import axios from "axios";
import {getLink} from "../functions";

export default function initPoukazky() {
	const poukazky = new Map();
	let alertDom;
	const parentForm = document.getElementById('poukazky-form');
	const step1 = document.getElementById('step1');
	/**
	 * @type {HTMLInputElement}
	 */
	const jmeno = document.getElementById('jmeno');
	/**
	 * @type {HTMLInputElement}
	 */
	const prijmeni = document.getElementById('prijmeni');
	/**
	 * @type {HTMLInputElement}
	 */
	const email = document.getElementById('email');
	/**
	 * @type {HTMLInputElement}
	 */
	const vop = document.getElementById('vop');

	jmeno.addEventListener('input', () => {
		jmeno.parentElement.classList.remove('invalid');
	});
	prijmeni.addEventListener('input', () => {
		prijmeni.parentElement.classList.remove('invalid');
	});
	email.addEventListener('input', () => {
		email.parentElement.classList.remove('invalid');
	});
	vop.addEventListener('change', () => {
		vop.parentElement.parentElement.classList.remove('invalid');
	});

	const total = document.getElementById('poukazky-total-val');
	let totalValue = 0.0;

	const pridatPoukazku = document.getElementById('pridat-poukazku');

	class Poukazka {

		constructor(id) {

			this.id = id;
			this.config = {};
			this.type = null;
			this.title = '';
			this.price = 0;

			const template = document.getElementById('poukazka').innerHTML.replaceAll('#', id);
			const tmp = document.createElement('div');
			tmp.innerHTML = template;

			// DOM
			this.dom = tmp.firstElementChild;
			this.$form = this.dom.querySelector('.poukazka-inner-form');
			this.$type = this.dom.querySelector('.poukazka-type');
			this.$hiddenType = this.dom.querySelector('.poukazka-hidden-type');
			this.$previewBox = this.dom.querySelector('.container-ajax');
			this.$remove = this.dom.querySelector('.poukazka-remove');
			this.$content = null;

			if (id === 0) {
				this.$remove.classList.add('d-none');
			}

			Object.keys(config).forEach(key => {
				const value = config[key];
				const option = document.createElement('option');
				option.value = key;
				option.innerText = value.title;
				this.$type.appendChild(option);
			});

			// Triggers
			this.$type.addEventListener('change', () => {
				this.changeType(this.$type.value);
			});
			this.$remove.addEventListener('click', this.remove)
		}

		remove() {
			this.dom.remove();
			updateTotal(-this.price);
			poukazky.delete(this.id);
		}

		/**
		 *
		 * @param templateId {String}
		 * @returns {null|Element}
		 */
		addInput(templateId) {
			const template = document.getElementById(templateId);
			if (!template) {
				return null;
			}
			const tmp = document.createElement('div');
			tmp.innerHTML = template.innerHTML.replaceAll('#', this.id.toString());
			const input = tmp.firstElementChild;
			this.$form.appendChild(input);
			return input;
		}

		changeType(key) {
			// Reset
			updateTotal(-this.price);
			this.price = 0;
			this.clearPreview();
			this.clearForm();

			if (!config[key]) {
				this.config = {};
				this.$hiddenType.value = -1;
				return false;
			}

			this.$type.parentElement.classList.remove('invalid');

			this.config = config[key];

			console.log("changing type", key, config[key])

			this.type = config[key].id;
			this.title = config[key].title;
			const tmp = document.createElement('div');
			tmp.innerHTML = config[key].htmlContent;
			this.$content = tmp;
			this.$content.querySelectorAll('a').forEach(link => {
				link.setAttribute('target', '_blank');
			});
			this.$hiddenType.value = config[key].id;

			// Update preview
			this.$previewBox.style.backgroundImage = `url(${config[key].image})`;
			this.$previewBox.appendChild(this.$content);

			// Update form
			const $option = this.addInput('poukazka-option').querySelector('select');
			if (typeof config[key].options === 'object') {
				Object.values(config[key].options).forEach(val => {
					const option = document.createElement('option');
					option.value = val.key;
					option.innerText = val.label;
					$option.appendChild(option);
				});
			}
			else {
				console.log(config[key], this.config);
			config[key].options.forEach(val => {
				const option = document.createElement('option');
				option.value = val.key;
				option.innerText = val.label;
				$option.appendChild(option);
			});
			}

			let quantity = null;
			if (config[key].custom) {
				this.addInput('poukazka-hidden-quantity');
			} else {
				quantity = this.addInput('poukazka-quantity').querySelector('input');
				quantity.addEventListener('change', () => {
					let option = parseInt($option.value);
					if (!this.config.noPrice) {
						console.log(option, this.config);
						let newPrice = this.config.options[option].price * parseInt(this.config.custom ? 1 : quantity.value);
						let diff = newPrice - this.price;
						updateTotal(diff);
						this.price = newPrice;
					}
				});
			}

			if (config[key].custom) {
				const title = this.addInput('poukazka-title').querySelector('input');
				const contentTitle = this.$content.querySelector('[rel="title"]');
				contentTitle.innerText = title.value;
				title.addEventListener('input', () => {
					contentTitle.innerText = title.value;
				});
				const description = this.addInput('poukazka-description').querySelector('textarea');
				const contentDescription = this.$content.querySelector('[rel="desc"]');
				contentDescription.innerText = description.value;
				description.addEventListener('input', () => {
					contentDescription.innerText = description.value;
				});
			}

			$option.addEventListener('change', () => {
				$option.parentElement.classList.remove('invalid');
				let option = parseInt($option.value);
				if (option === -1) {
					updateTotal(-this.price);
					this.price = 0;
				} else if (!this.config.noPrice) {
					let newPrice = this.config.options[option].price * parseInt(this.config.custom || !quantity ? 1 : quantity.value);
					let diff = newPrice - this.price;
					updateTotal(diff);
					this.price = newPrice;
				}
				const priceDom = this.$content.querySelector('span[rel="price"]');
				if (priceDom) {
					priceDom.innerText = this.config.options[option].price;
				}
				const timeDom = this.$content.querySelector('span[rel="time"]');
				if (timeDom) {
					timeDom.innerText = this.config.options[option].label;
				}
				let games;
				const gamesDom = this.$content.querySelector('span[rel="games"]');
				if (gamesDom) {
					if (strings.games[poukazka.config.options[option].price]) {
						games = poukazka.config.options[option].price;
					} else {
						games = strings.games[5];
					}
					gamesDom.innerText = games;
				}
			});
		}

		clearPreview() {
			this.$previewBox.style.backgroundImage = '';
			this.$previewBox.innerHTML = '';
		}

		clearForm() {
			this.$form.innerHTML = '';
		}

		/**
		 *
		 * @param parent {Element}
		 */
		appendTo(parent) {
			parent.insertBefore(this.dom, parent.querySelector('#btns1'));
		}

		validate() {
			if (parseInt(this.$type.value) === -1) {
				this.$type.parentElement.classList.add('invalid');
				return false;
			}
			const option = this.$form.querySelector('.poukazka-option');
			if (option && parseInt(option.value) === -1) {
				option.parentElement.classList.add('invalid');
				return false;
			}
			const quantity = this.$form.querySelector('.poukazka-quantity');
			if (quantity && parseInt(quantity.value) <= 0) {
				quantity.parentElement.classList.add('invalid');
				return false;
			}
			if (this.config.custom) {
				const title = this.$form.querySelector('.poukazka-title');
				if (title && title.value === "") {
					title.parentElement.classList.add('invalid');
					return false
				}
				const description = this.$form.querySelector('.poukazka-description');
				if (description && description.value === "") {
					description.parentElement.classList.add('invalid');
					return false;
				}
			}
			return true;
		}

	}

	document.querySelectorAll('.step, .next-step').forEach(btn => {
		btn.addEventListener('click', () => {
			if (btn.classList.contains('locked')) {
				return;
			}
			const step = parseInt(btn.dataset.step);
			const activeStep = parseInt(document.querySelector('.step.active').dataset.step);
			let valid = true;

			if (activeStep === 1) {
				poukazky.forEach(poukazka => {
					console.log(poukazka.id, poukazka.validate());
					if (!poukazka.validate()) {
						valid = false;
						return false;
					}
				});
			}
			if (!valid) {
				return;
			}
			// Validate step 2
			else if (activeStep === 2 && step > activeStep) {
				if (jmeno.value.length < 3) {
					jmeno.parentElement.classList.add('invalid');
					return false;
				}
				if (prijmeni.value.length < 3) {
					prijmeni.parentElement.classList.add('invalid');
					return false;
				}
				let re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
				if (!re.test(email.value.toLowerCase())) {
					email.parentElement.classList.add('invalid');
					return false;
				}
			}

			if (step === 2) {
				poukazky.forEach(function (poukazka) {
					let data = {
						content_type: "product",
						value: poukazka.price,
						content_name: poukazka.title,
						currency: "CZK"
					};
					console.log("Calling fb", data);
					//fbq("track", "AddToCart", data);
				});
			}
			if (step === 3) {
				calcSummary(poukazky);
				document.getElementById('kontakt-table-jmeno').innerHTML = `${jmeno.value} ${prijmeni.value}`;
				document.getElementById('kontakt-table-mail').innerHTML = email.value;
			}

			moveToStep(step);
		});
	});

	parentForm.addEventListener('submit', e => {
		e.preventDefault();

		// Validate step 1
		let invalidStep = 0;
		let valid = true;
		poukazky.forEach(poukazka => {
			console.log(poukazka.id, poukazka.validate());
			if (!poukazka.validate()) {
				valid = false;
				invalidStep = 1;
				return false;
			}
		});
		// Validate step 2
		if (jmeno.value.length < 3) {
			jmeno.parentElement.classList.add('invalid');
			valid = false;
			invalidStep = 2;
		}
		if (prijmeni.value.length < 3) {
			prijmeni.parentElement.classList.add('invalid');
			valid = false;
			invalidStep = 2;
		}
		let re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		if (!re.test(email.value.toLowerCase())) {
			email.parentElement.classList.add('invalid');
			valid = false;
			invalidStep = 2;
		}
		// Validate step 3
		if (vop && !vop.checked && valid) {
			vop.parentElement.parentElement.classList.add('invalid');
			valid = false;
			invalidStep = 3;
		}
		/*if (grecaptcha.getResponse() === "" && valid) {
			$('#captcha').addClass('invalid');
			valid = false;
			invalidStep = 3;
		}*/
		console.log('valid', valid, invalidStep);
		if (!valid) {
			alert(strings.alert);
			if (invalidStep === 3) {
				calcSummary(poukazky);
			}
			moveToStep(invalidStep);
			return false;
		}

		startLoading();

		axios.post('/poukazky/save', new FormData(parentForm))
			.then(response => {
				stopLoading();
				if (fbq) fbq('track', 'Purchase', {value: totalValue, currency: 'CZK'});
				if (response.data.payment) {
					window.location = response.data.payment;
					return;
				}
				if (response.data.redirect) {
					window.location = response.data.redirect;
					return;
				}
				window.location = getLink(['poukazky', 'thank-you'])
			})
			.catch(response => {
				stopLoading(false);
				if (response.data.error) {
					alert(response.data.error);
				}
			});
	});

	// Init first
	let i = 0;
	poukazky.set(i, new Poukazka(i));
	poukazky.get(i).appendTo(step1);
	i++;
	if (fbq) fbq('track', 'AddToCart');

	pridatPoukazku.addEventListener('click', () => {
		let poukazka = new Poukazka(i);
		poukazky.set(i, poukazka);
		poukazka.appendTo(step1);
		i++;
		if (fbq) fbq('track', 'AddToCart');
	});

	/**
	 * @param diff {Number}
	 */
	function updateTotal(diff) {
		const val = parseInt(total.innerText);
		totalValue = val + diff;
		total.innerText = totalValue.toString();
	}

	/**
	 * @param poukazky {Map<Poukazka>}
	 */
	function calcSummary(poukazky) {

		const $summaryTable = document.getElementById('table-summary');
		const $summaryTotal = document.getElementById('summary-total');

		$summaryTable.querySelector('tbody').innerHTML = '';

		let i = 1;
		let sum = 0;
		poukazky.forEach(poukazka => {
			let $tr = document.createElement('tr');
			$tr.innerHTML = `<td>${i}.</td>`;
			let option = parseInt(poukazka.dom.querySelector('.poukazka-option').value);
			let optionText = "";
			if (isNaN(poukazka.config.options[option].label)) {
				optionText = poukazka.config.options[option].label;
			} else if (poukazka.config.noPrice) {
				let games;
				if (strings.games[poukazka.config.options[option].price]) {
					games = poukazka.config.options[option].price;
				} else {
					games = strings.games[5];
				}
				optionText = poukazka.config.options[option].price + " " + games;
			} else {
				optionText = `${poukazka.config.options[option].price}&nbsp;Kč`;
			}
			let td = document.createElement('td');
			td.innerHTML = `${poukazka.dom.querySelector('.poukazka-quantity').value}&times; - ${poukazka.title} - ${optionText}`;
			$tr.appendChild(td);
			td = document.createElement('td');
			td.innerHTML = `${poukazka.price}&nbsp;Kč`;
			$tr.appendChild(td);
			$summaryTable.querySelector('tbody').appendChild($tr);
			sum += poukazka.price;
			i++;
		});
		$summaryTotal.innerHTML = sum;

	}

	/**
	 * @param step {Number}
	 */
	function moveToStep(step) {
		document.querySelectorAll('.step-block.active, .step.active').forEach(elem => {
			elem.classList.remove('active');
		});
		setTimeout(() => {
			document.querySelectorAll(`#step${step}, .step[data-step="${step}"]`).forEach(elem => {
				elem.classList.add('active');
				elem.classList.remove('locked');
			})
		}, 400);
	}

	/**
	 * @param text {String}
	 */
	function alert(text) {
		if (alertDom) {
			alertDom.remove();
		}
		alertDom = document.createElement('div');
		alertDom.classList.add('alert', 'alert-danger');
		alertDom.innerText = text;
		parentForm.insertBefore(alertDom, parentForm.firstChild);
	}
}